export interface Employee {
  new_name: string;
  new_employeeid: string;
  cra0e_email: string;
}

export interface Skill {
  id: string;
  name: string;
  category: OptionSet;
}

export interface OptionSet {
  label: string;
  value: string;
}
export interface EmployeeSkill {
  id: string;
  skill: Omit<Skill, 'category'>;
  level: OptionSet;
  employee: Employee;
  attitude: OptionSet;
  category: OptionSet;
  requestedLevel?: OptionSet;
  requestedAttitude?: OptionSet;
  requestedDate?: string;
  validatedDate?: string;
  validatedBy?: string;
}

export interface EmployeeSkillsByCategoryDTO {
  category: OptionSet;
  employeeSkills: EmployeeSkill[];
}

export enum Attitude {
  POSITIVE = '759590000',
  NEUTRAL = '759590001',
  NEGATIVE = '759590002',
}

export enum Level {
  LEVEL1 = '759590000',
  LEVEL2 = '759590001',
  LEVEL3 = '759590002',
}
